/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
export type ItemTagFragment = {
  __typename: 'ItemTag'
  id: string
  name: string
  imageSvgUrl: string | null
  highlighted: boolean
}

export const ItemTagFragment = ({
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ItemTagFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ItemTag' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageSvgUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'highlighted' } }
        ]
      }
    }
  ]
} as unknown) as DocumentNode
